const Emitter = require('eventemitter3');
module.exports = new Emitter();